/* =========================================================
   SHARED SITE LIGHTBOX + METAL TAROT GALLERY
   ========================================================= */

(function () {
  'use strict';

  function initSharedLightbox() {
    const lightbox = document.getElementById('gallery-lightbox');
    if (!lightbox || lightbox.dataset.lightboxJsReady === 'true') return;
    lightbox.dataset.lightboxJsReady = 'true';

    const lightboxImage = lightbox.querySelector('.gallery-lightbox-image');
    const media = lightbox.querySelector('.gallery-lightbox-media');
    const closeButton = lightbox.querySelector('.gallery-lightbox-close');
    const prevButton = lightbox.querySelector('.gallery-lightbox-nav-prev');
    const nextButton = lightbox.querySelector('.gallery-lightbox-nav-next');
    const kicker = lightbox.querySelector('.gallery-lightbox-kicker');
    const ctaText = lightbox.querySelector('#gallery-lightbox-cta-text');
    const supportText = lightbox.querySelector('.gallery-lightbox-support');
    const meta = lightbox.querySelector('#gallery-lightbox-meta');
    const counter = lightbox.querySelector('#gallery-lightbox-counter');
    const collectionLink = lightbox.querySelector('#gallery-lightbox-collection-link');
    const reviewBox = lightbox.querySelector('#gallery-lightbox-review');
    const reviewText = lightbox.querySelector('#gallery-lightbox-review-text');
    const reviewAuthor = lightbox.querySelector('#gallery-lightbox-review-author');
    const primaryCta = lightbox.querySelector(
      'a.gallery-lightbox-cta, a.gallery-lightbox-primary-link'
    );
    const bulkLink = lightbox.querySelector('.gallery-lightbox-bulk-link');
    const contactLink = lightbox.querySelector('.gallery-lightbox-contact-link');

    if (!lightboxImage) return;

    const prefersReducedMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const BASE_ORDER_URL =
      'https://www.custommetalbusinesscards.com/products/makecards';


    /* =========================================================
       FEATURED GALLERY CTA HEADLINES
       ========================================================= */

    const ctaMessages = [
      'Love this look? Let’s make yours.',
      'Your artwork deserves better than paper. Put it on metal.',
      'Ready to stand out? Turn your design into metal.',
      'Got an idea? Turn it into metal.',
      'Make a card they’ll actually remember.',
      'See something you like? Let’s make your version.',
      'Your brand deserves better than paper.',
      'From your design to solid metal.'
    ];


    /* =========================================================
       REVIEWS
       ========================================================= */

    const lightboxReviews = [
      {
        name: 'Matt K.',
        text: 'These cards are phenomenal quality and the engraving is perfect.'
      },
      {
        name: 'Amber',
        text: 'Amazing quality and super fast shipping!'
      },
      {
        name: 'Kyle B.',
        text: 'The detail in the engraving is amazing.'
      },
      {
        name: 'Chris A.',
        text: 'High quality and attention to detail is superb.'
      },
      {
        name: 'Stephanie W.',
        text: 'Super fast shipping and the quality is outstanding.'
      },
      {
        name: 'Frankie',
        text: 'Wonderful product exceeded my expectations.'
      },
      {
        name: 'Jenna L.',
        text: 'I’ve purchased multiple times and I’m always impressed.'
      },
      {
        name: 'Jason T.',
        text: 'These look amazing. Great customer service.'
      },
      {
        name: 'Tyler C.',
        text: 'Excellent response time, high quality product, fast shipping time.'
      },
      {
        name: 'Hannah S.',
        text: 'This is awesome! Arrived quickly, exactly as described. Will buy again.'
      },
      {
        name: 'Megan R.',
        text: 'Exactly what I wanted and delivered quickly.'
      },
      {
        name: 'Nicole F.',
        text: 'Great seller, answered all my questions quickly.'
      }
    ];


    /* =========================================================
       CUSTOMER FAVORITE COLOR VARIANTS
       ========================================================= */

    const colorProfiles = {
      'MATTE BLACK': {
        color: 'Matte Black',
        url:
          'https://www.custommetalbusinesscards.com/products/makecards?variant=44010494394530'
      },

      'BLUE ANODIZED': {
        color: 'Blue',
        url:
          'https://www.custommetalbusinesscards.com/products/makecards?variant=44787649216674'
      },

      GREEN: {
        color: 'Green',
        url:
          'https://www.custommetalbusinesscards.com/products/makecards?variant=44787649249442'
      },

      PURPLE: {
        color: 'Purple',
        url:
          'https://www.custommetalbusinesscards.com/products/makecards?variant=45737597730978'
      },

      RED: {
        color: 'Red',
        url:
          'https://www.custommetalbusinesscards.com/products/makecards?variant=44787649314978'
      },

      'ROSE GOLD': {
        color: 'Rose Gold',
        url:
          'https://www.custommetalbusinesscards.com/products/makecards?variant=44787649282210'
      },

      SILVER: {
        color: 'Silver',
        url:
          'https://www.custommetalbusinesscards.com/products/makecards?variant=45737597665442'
      },

      GOLD: {
        color: 'Gold',
        url:
          'https://www.custommetalbusinesscards.com/products/makecards?variant=45737597698210'
      },

      WHITE: {
        color: 'White',
        url:
          'https://www.custommetalbusinesscards.com/products/makecards?variant=45737597632674'
      }
    };


    /* =========================================================
       FIND YOUR LOOK
       ========================================================= */

    const styleProfiles = {
      'MINIMAL & MODERN': {
        kicker: 'EXPLORE THIS STYLE',
        headline: 'Clean design. Serious first impression.',
        support:
          'Turn a simple logo, name, QR code, or contact details into a sharp metal card with a clean professional look.',
        meta:
          'MINIMAL & MODERN • LASER ENGRAVED ALUMINUM',
        primaryText:
          'CREATE A MINIMAL METAL CARD →',
        primaryUrl:
          BASE_ORDER_URL,
        collectionTitle:
          'Explore Custom Metal Business Cards',
        collectionUrl:
          '/collections/custom-metal-business-cards'
      },

      'PREMIUM & LUXURY': {
        kicker: 'EXPLORE THIS STYLE',
        headline: 'Give your brand the luxury treatment.',
        support:
          'Create a high-end metal card built for premium brands, memorable introductions, and details that deserve to stand out.',
        meta:
          'PREMIUM & LUXURY • LASER ENGRAVED ALUMINUM',
        primaryText:
          'CREATE A PREMIUM METAL CARD →',
        primaryUrl:
          BASE_ORDER_URL,
        collectionTitle:
          'Explore Custom Metal Business Cards',
        collectionUrl:
          '/collections/custom-metal-business-cards'
      },

      'BOLD & INDUSTRIAL': {
        kicker: 'EXPLORE THIS STYLE',
        headline: 'Go bold. Make the card impossible to ignore.',
        support:
          'Strong artwork, hard lines, and high-contrast engraving translate beautifully to anodized aluminum.',
        meta:
          'BOLD & INDUSTRIAL • LASER ENGRAVED ALUMINUM',
        primaryText:
          'CREATE A BOLD METAL CARD →',
        primaryUrl:
          BASE_ORDER_URL,
        collectionTitle:
          'Explore Custom Metal Business Cards',
        collectionUrl:
          '/collections/custom-metal-business-cards'
      },

      'QR CODE CARDS': {
        kicker: 'EXPLORE THIS STYLE',
        headline: 'Put more than contact info in their pocket.',
        support:
          'Add a scannable QR code for your website, portfolio, menu, social profile, payment link, or anything else you want to share.',
        meta:
          'QR CODE CARD • LASER ENGRAVED ALUMINUM',
        primaryText:
          'CREATE A QR CODE METAL CARD →',
        primaryUrl:
          BASE_ORDER_URL,
        collectionTitle:
          'Explore Custom Metal Business Cards',
        collectionUrl:
          '/collections/custom-metal-business-cards'
      },

      'COLOR & ANODIZED': {
        kicker: 'EXPLORE THIS STYLE',
        headline: 'Pick a finish that fits your brand.',
        support:
          'Choose from nine anodized colors and pair your artwork with a finish that makes the design feel unmistakably yours.',
        meta:
          '9 COLORS • ANODIZED ALUMINUM • LASER ENGRAVED',
        primaryText:
          'CHOOSE YOUR CARD COLOR →',
        primaryUrl:
          BASE_ORDER_URL,
        collectionTitle:
          'Explore Custom Metal Business Cards',
        collectionUrl:
          '/collections/custom-metal-business-cards'
      },

      'MADE IN USA': {
        kicker: 'EXPLORE THIS STYLE',
        headline: 'Made in South Carolina. Built for your brand.',
        support:
          'Your custom card is laser engraved in Upstate South Carolina with fast turnaround and hands-on production.',
        meta:
          'MADE IN USA • LASER ENGRAVED ALUMINUM',
        primaryText:
          'CREATE YOUR USA-MADE CARD →',
        primaryUrl:
          BASE_ORDER_URL,
        collectionTitle:
          'Explore Custom Metal Business Cards',
        collectionUrl:
          '/collections/custom-metal-business-cards'
      }
    };


    /* =========================================================
       COLLECTION MATCHING
       ========================================================= */

    const collectionRules = [
      {
        keywords: [
          'tarot',
          'magician',
          'tower'
        ],
        title:
          'Explore Metal Tarot Cards',
        url:
          '/collections/metal-tarot-cards',
        type:
          'Tarot Card'
      },

      {
        keywords: [
          'ace of',
          'queen of',
          'king of',
          'joker',
          'poker',
          'playing card',
          'playing cards'
        ],
        title:
          'Explore Metal Playing Cards',
        url:
          '/collections/metal-playing-cards',
        type:
          'Playing Card'
      },

      {
        keywords: [
          'pilot',
          'aviation',
          'boarding pass',
          'aircraft',
          'airplane',
          'flight'
        ],
        title:
          'Explore Aviation & Pilot Gifts',
        url:
          '/collections/metal-aviation-pilot-gifts',
        type:
          'Aviation Gift'
      },

      {
        keywords: [
          'veteran',
          'enlistment',
          'patriotic',
          'military'
        ],
        title:
          'Explore Patriotic & Veteran Gifts',
        url:
          '/collections/patriotic-veteran-gifts',
        type:
          'Patriotic Keepsake'
      },

      {
        keywords: [
          'bible',
          'scripture',
          'john ',
          'religious',
          'faith',
          'grace',
          'inspirational'
        ],
        title:
          'Explore Religious & Inspirational Gifts',
        url:
          '/collections/religious-inspirational-gifts',
        type:
          'Inspirational Keepsake'
      },

      {
        keywords: [
          'love',
          'hugs',
          'mom',
          'mother',
          'romantic',
          'relationship'
        ],
        title:
          'Explore Love & Relationship Gifts',
        url:
          '/collections/love-relationships',
        type:
          'Keepsake'
      },

      {
        keywords: [
          'workplace',
          'work here',
          'one job',
          'forklift',
          'coworker',
          'office humor'
        ],
        title:
          'Explore Workplace Humor',
        url:
          '/collections/workplace-humor',
        type:
          'Workplace Keepsake'
      },

      {
        keywords: [
          'funny',
          'hater',
          'gag gift',
          'neighbor',
          'idiot',
          'secret agent',
          'immigration'
        ],
        title:
          'Explore Funny Metal Gag Gifts',
        url:
          '/collections/funny-metal-gag-gifts',
        type:
          'Metal Gag Gift'
      },

      {
        keywords: [
          'gaming',
          'gamer',
          'video game'
        ],
        title:
          'Explore Gaming Gifts',
        url:
          '/collections/gaming-gifts',
        type:
          'Gaming Keepsake'
      },

      {
        keywords: [
          'sign',
          'placard',
          'no trespassing',
          'private property',
          'handwashing',
          'wifi',
          'no soliciting',
          'recording notice',
          'must be 21',
          'bon appetit'
        ],
        title:
          'Explore Metal Signs',
        url:
          '/collections/restaurant-bar-signs',
        type:
          'Metal Sign'
      },

      {
        keywords: [
          'keepsake',
          'gift',
          'portrait'
        ],
        title:
          'Explore Best-Selling Metal Keepsakes',
        url:
          '/collections/best-selling-metal-keepsakes',
        type:
          'Keepsake'
      },

      {
        keywords: [
          'business card',
          'realtor',
          'tattoo',
          'auto detailing',
          'qr code',
          'scannable',
          'content creator',
          'dog sitter',
          'electrician',
          'contact card',
          'barber'
        ],
        title:
          'Explore Custom Metal Business Cards',
        url:
          '/collections/custom-metal-business-cards',
        type:
          'Business Card'
      }
    ];


    /* =========================================================
       COLOR MATCHING
       ========================================================= */

    const featuredColorRules = [
      {
        keywords: [
          'rose gold',
          'rose-gold',
          'love-never-fails-keepsake-card-mockup',
          'best-mom-ever'
        ],
        color:
          'Rose Gold'
      },

      {
        keywords: [
          'purple anodized',
          'purple-metal',
          'purple metal'
        ],
        color:
          'Purple'
      },

      {
        keywords: [
          'red anodized',
          'red-metal',
          'red metal'
        ],
        color:
          'Red'
      },

      {
        keywords: [
          'blue anodized',
          'blue-metal',
          'blue metal'
        ],
        color:
          'Blue'
      },

      {
        keywords: [
          'green anodized',
          'green-metal',
          'green metal'
        ],
        color:
          'Green'
      },

      {
        keywords: [
          'white silver',
          'white-metal',
          'white metal'
        ],
        color:
          'White'
      },

      {
        keywords: [
          'silver anodized',
          'silver-metal',
          'silver metal'
        ],
        color:
          'Silver'
      },

      {
        keywords: [
          'gold anodized',
          'gold-metal',
          'gold metal'
        ],
        color:
          'Gold'
      },

      {
        keywords: [
          'matte black',
          'black-metal',
          'black metal'
        ],
        color:
          'Matte Black'
      }
    ];


    /* =========================================================
       STANDARD LIGHTBOX GROUPS
       ========================================================= */

    const groups = {

      styles:
        Array.from(
          document.querySelectorAll(
            '.gallery-category-card'
          )
        )
          .map(function (card) {
            return {
              group:
                'styles',

              trigger:
                card,

              image:
                card.querySelector('img'),

              label:
                (
                  (
                    card.querySelector('h3') ||
                    {}
                  ).textContent ||
                  ''
                )
                  .trim()
                  .toUpperCase()
            };
          })
          .filter(function (entry) {
            return entry.image;
          }),


      featured:
        Array.from(
          document.querySelectorAll(
            '.featured-gallery-section .gallery-item img:not([data-lightbox-group])'
          )
        )
          .map(function (img) {
            return {
              group:
                'featured',

              trigger:
                img,

              image:
                img,

              label:
                img.alt ||
                'Custom metal card'
            };
          }),


      colors:
        Array.from(
          document.querySelectorAll(
            '.popular-style-card'
          )
        )
          .map(function (card) {
            return {
              group:
                'colors',

              trigger:
                card,

              image:
                card.querySelector('img'),

              label:
                (
                  (
                    card.querySelector('h3') ||
                    {}
                  ).textContent ||
                  ''
                )
                  .trim()
                  .toUpperCase()
            };
          })
          .filter(function (entry) {
            return entry.image;
          }),


      premium:
        Array.from(
          document.querySelectorAll(
            '.premium-lightbox-section .premium-lightbox-item img:not([data-lightbox-group])'
          )
        )
          .map(function (img) {
            return {
              group:
                'premium',

              trigger:
                img,

              image:
                img,

              label:
                img.alt ||
                'Custom VIP metal card'
            };
          })

    };


    /* =========================================================
       CUSTOM DATA GROUPS
       ========================================================= */

    const dataGroupEntries =
      Array.from(
        document.querySelectorAll(
          'img[data-lightbox-group]'
        )
      )
        .map(function (img) {
          return {
            group:
              img.getAttribute(
                'data-lightbox-group'
              ),

            trigger:
              img,

            image:
              img,

            label:
              img.alt ||
              'Custom metal project'
          };
        })
        .filter(function (entry) {
          return (
            entry.group &&
            entry.image
          );
        });


    dataGroupEntries.forEach(function (entry) {

      if (
        !groups[
          entry.group
        ]
      ) {
        groups[
          entry.group
        ] = [];
      }

      groups[
        entry.group
      ].push(
        entry
      );

    });


    const allEntries =
      Object.keys(
        groups
      )
        .reduce(
          function (
            result,
            key
          ) {
            return result.concat(
              groups[key]
            );
          },
          []
        );


    /* =========================================================
       STATE
       ========================================================= */

    let activeEntries = [];
    let currentIndex = 0;
    let currentGroup = 'featured';
    let sessionFeaturedHeadline = ctaMessages[0];
    let lastCtaIndex = -1;
    let reviewIndex = -1;
    let lastFocusedElement = null;
    let previousBodyOverflow = '';
    let imageSwapToken = 0;
    let touchStartX = null;
    let touchStartY = null;


    /* =========================================================
       HELPERS
       ========================================================= */

    function imageSource(img) {

      if (!img) {
        return '';
      }

      return (
        img.currentSrc ||
        img.getAttribute(
          'src'
        ) ||
        img.getAttribute(
          'data-src'
        ) ||
        ''
      );

    }


    function searchableText(image) {

      return (
        (
          image.alt ||
          ''
        ) +
        ' ' +
        imageSource(
          image
        )
      ).toLowerCase();

    }


    function isStandaloneGroup(groupName) {

      return (
        typeof groupName ===
          'string' &&
        groupName.indexOf(
          'standalone-'
        ) === 0
      );

    }


    function isCustomDataGroup(groupName) {

      return (
        typeof groupName ===
          'string' &&
        groupName !==
          'styles' &&
        groupName !==
          'featured' &&
        groupName !==
          'colors' &&
        groupName !==
          'premium' &&
        !isStandaloneGroup(
          groupName
        )
      );

    }


    function chooseRandomFeaturedHeadline() {

      let newIndex =
        Math.floor(
          Math.random() *
          ctaMessages.length
        );


      if (
        ctaMessages.length >
          1 &&
        newIndex ===
          lastCtaIndex
      ) {

        newIndex =
          (
            newIndex +
            1 +
            Math.floor(
              Math.random() *
              (
                ctaMessages.length -
                1
              )
            )
          ) %
          ctaMessages.length;

      }


      lastCtaIndex =
        newIndex;


      sessionFeaturedHeadline =
        ctaMessages[
          newIndex
        ];

    }


    function getFeaturedCollection(image) {

      const manualTitle =
        image.getAttribute(
          'data-collection-title'
        );


      const manualUrl =
        image.getAttribute(
          'data-collection-url'
        );


      const manualType =
        image.getAttribute(
          'data-type'
        );


      if (
        manualTitle &&
        manualUrl
      ) {

        return {
          title:
            manualTitle,

          url:
            manualUrl,

          type:
            manualType ||
            'Custom Metal Card'
        };

      }


      const searchable =
        searchableText(
          image
        );


      for (
        let i = 0;
        i < collectionRules.length;
        i++
      ) {

        const rule =
          collectionRules[
            i
          ];


        if (
          rule.keywords.some(
            function (
              keyword
            ) {

              return searchable.includes(
                keyword.toLowerCase()
              );

            }
          )
        ) {

          return rule;

        }

      }


      return {
        title:
          'Explore Custom Metal Business Cards',

        url:
          '/collections/custom-metal-business-cards',

        type:
          manualType ||
          'Custom Metal Card'
      };

    }


    function getFeaturedColor(image) {

      const manualColor =
        image.getAttribute(
          'data-color'
        );


      if (
        manualColor
      ) {
        return manualColor;
      }


      const searchable =
        searchableText(
          image
        );


      for (
        let i = 0;
        i < featuredColorRules.length;
        i++
      ) {

        const rule =
          featuredColorRules[
            i
          ];


        if (
          rule.keywords.some(
            function (
              keyword
            ) {

              return searchable.includes(
                keyword.toLowerCase()
              );

            }
          )
        ) {

          return rule.color;

        }

      }


      return '';

    }


    /* =========================================================
       CONTEXT
       ========================================================= */

    function applyContext(entry) {

      if (
        !entry ||
        !entry.image
      ) {
        return;
      }


      /* =====================================================
         COLORS
         ===================================================== */

      if (
        entry.group ===
        'colors'
      ) {

        const profile =
          colorProfiles[
            entry.label
          ] ||
          {
            color:
              entry.label.replace(
                ' ANODIZED',
                ''
              ),

            url:
              BASE_ORDER_URL
          };


        if (kicker) {
          kicker.textContent =
            'CHOOSE YOUR FINISH';
        }


        if (ctaText) {
          ctaText.textContent =
            'Make it yours in ' +
            profile.color.toLowerCase() +
            '.';
        }


        if (supportText) {
          supportText.textContent =
            'Start with this finish, then upload your logo, artwork, text, photo, or QR code — we’ll handle the rest.';
        }


        if (meta) {
          meta.textContent =
            profile.color +
            ' • Business Card • Laser Engraved Aluminum';
        }


        if (primaryCta) {

          primaryCta.href =
            profile.url;


          primaryCta.textContent =
            'CREATE YOUR ' +
            profile.color.toUpperCase() +
            ' CARD →';

        }


        if (collectionLink) {

          collectionLink.href =
            '/collections/custom-metal-business-cards';


          collectionLink.textContent =
            'Explore Custom Metal Business Cards →';

        }


        return;

      }


      /* =====================================================
         STYLE CARDS
         ===================================================== */

      if (
        entry.group ===
        'styles'
      ) {

        const profile =
          styleProfiles[
            entry.label
          ] ||
          {
            kicker:
              'EXPLORE THIS STYLE',

            headline:
              'Turn this look into your own metal card.',

            support:
              'Upload your logo, artwork, text, photo, or QR code — we’ll handle the rest.',

            meta:
              entry.label +
              ' • LASER ENGRAVED ALUMINUM',

            primaryText:
              'CREATE YOUR CUSTOM CARD →',

            primaryUrl:
              BASE_ORDER_URL,

            collectionTitle:
              'Explore Custom Metal Business Cards',

            collectionUrl:
              '/collections/custom-metal-business-cards'
          };


        if (kicker) {
          kicker.textContent =
            profile.kicker;
        }


        if (ctaText) {
          ctaText.textContent =
            profile.headline;
        }


        if (supportText) {
          supportText.textContent =
            profile.support;
        }


        if (meta) {
          meta.textContent =
            profile.meta;
        }


        if (primaryCta) {

          primaryCta.href =
            profile.primaryUrl;


          primaryCta.textContent =
            profile.primaryText;

        }


        if (collectionLink) {

          collectionLink.href =
            profile.collectionUrl;


          collectionLink.textContent =
            profile.collectionTitle +
            ' →';

        }


        return;

      }


      /* =====================================================
         CUSTOM DATA GROUPS + STANDALONE
         ===================================================== */

      if (
        isCustomDataGroup(
          entry.group
        ) ||
        isStandaloneGroup(
          entry.group
        )
      ) {

        const image =
          entry.image;


        const collection =
          getFeaturedCollection(
            image
          );


        const customKicker =
          image.getAttribute(
            'data-lightbox-kicker'
          );


        const customHeadline =
          image.getAttribute(
            'data-lightbox-headline'
          );


        const customSupport =
          image.getAttribute(
            'data-lightbox-support'
          );


        const customPrimaryText =
          image.getAttribute(
            'data-primary-cta-text'
          );


        const customPrimaryUrl =
          image.getAttribute(
            'data-primary-cta-url'
          );


        const manualMeta =
          image.getAttribute(
            'data-meta'
          );


        if (kicker) {

          kicker.textContent =
            customKicker ||
            'MAKE YOUR OWN';

        }


        if (ctaText) {

          ctaText.textContent =
            customHeadline ||
            'Turn your idea into a premium metal card.';

        }


        if (supportText) {

          supportText.textContent =
            customSupport ||
            'Upload your logo, artwork, text, photo, or QR code — we’ll handle the rest.';

        }


        if (meta) {

          meta.textContent =
            manualMeta ||
            'CUSTOM PROJECT • LASER ENGRAVED ANODIZED ALUMINUM';

        }


        if (primaryCta) {

          primaryCta.href =
            customPrimaryUrl ||
            BASE_ORDER_URL;


          primaryCta.textContent =
            customPrimaryText ||
            'CREATE YOUR CUSTOM CARD →';

        }


        if (collectionLink) {

          collectionLink.href =
            collection.url;


          collectionLink.textContent =
            collection.title +
            ' →';

        }


        return;

      }


      /* =====================================================
         PREMIUM
         ===================================================== */

      if (
        entry.group ===
        'premium'
      ) {

        const collection =
          getFeaturedCollection(
            entry.image
          );


        const manualMeta =
          entry.image.getAttribute(
            'data-meta'
          );


        if (kicker) {
          kicker.textContent =
            'MAKE YOUR OWN';
        }


        if (ctaText) {
          ctaText.textContent =
            'Turn your idea into a premium metal card.';
        }


        if (supportText) {
          supportText.textContent =
            'Upload your logo, artwork, text, photo, or QR code — we’ll handle the rest.';
        }


        if (meta) {

          meta.textContent =
            manualMeta ||
            'CUSTOM VIP CARD • LASER ENGRAVED ALUMINUM';

        }


        if (primaryCta) {

          primaryCta.href =
            BASE_ORDER_URL;


          primaryCta.textContent =
            'CREATE YOUR CUSTOM CARD →';

        }


        if (collectionLink) {

          collectionLink.href =
            collection.url;


          collectionLink.textContent =
            collection.title +
            ' →';

        }


        return;

      }


      /* =====================================================
         FEATURED GALLERY
         ===================================================== */

      const collection =
        getFeaturedCollection(
          entry.image
        );


      const color =
        getFeaturedColor(
          entry.image
        );


      const manualMeta =
        entry.image.getAttribute(
          'data-meta'
        );


      if (kicker) {
        kicker.textContent =
          'MAKE YOUR OWN';
      }


      if (ctaText) {
        ctaText.textContent =
          sessionFeaturedHeadline;
      }


      if (supportText) {

        supportText.textContent =
          'Upload your logo, artwork, text, photo, or QR code — we’ll handle the rest.';

      }


      if (meta) {

        if (
          manualMeta
        ) {

          meta.textContent =
            manualMeta;

        } else {

          const pieces =
            [];


          if (
            color
          ) {

            pieces.push(
              color
            );

          }


          if (
            collection.type
          ) {

            pieces.push(
              collection.type
            );

          }


          pieces.push(
            'Laser Engraved Aluminum'
          );


          meta.textContent =
            pieces.join(
              ' • '
            );

        }

      }


      if (primaryCta) {

        primaryCta.href =
          BASE_ORDER_URL;


        primaryCta.textContent =
          'CREATE YOUR CUSTOM CARD →';

      }


      if (collectionLink) {

        collectionLink.href =
          collection.url;


        collectionLink.textContent =
          collection.title +
          ' →';

      }

    }


    /* =========================================================
       REVIEWS
       ========================================================= */

    function setReview(
      review,
      animate
    ) {

      if (
        !reviewBox ||
        !reviewText ||
        !reviewAuthor ||
        !review
      ) {
        return;
      }


      const applyReview =
        function () {

          reviewText.textContent =
            '“' +
            String(
              review.text ||
              ''
            ).trim() +
            '”';


          reviewAuthor.textContent =
            review.name
              ? '— ' +
                review.name
              : 'Verified customer';


          reviewBox.hidden =
            false;


          requestAnimationFrame(
            function () {

              reviewBox.classList.remove(
                'is-changing'
              );

            }
          );

        };


      if (
        animate &&
        !prefersReducedMotion
      ) {

        reviewBox.classList.add(
          'is-changing'
        );


        window.setTimeout(
          applyReview,
          90
        );

      } else {

        applyReview();

      }

    }


    function showRandomReview() {

      if (
        !lightboxReviews.length
      ) {
        return;
      }


      let nextIndex =
        Math.floor(
          Math.random() *
          lightboxReviews.length
        );


      if (
        lightboxReviews.length >
          1 &&
        nextIndex ===
          reviewIndex
      ) {

        nextIndex =
          (
            nextIndex +
            1 +
            Math.floor(
              Math.random() *
              (
                lightboxReviews.length -
                1
              )
            )
          ) %
          lightboxReviews.length;

      }


      reviewIndex =
        nextIndex;


      setReview(
        lightboxReviews[
          reviewIndex
        ],
        false
      );

    }


    function advanceReview() {

      if (
        !lightboxReviews.length
      ) {
        return;
      }


      reviewIndex =
        (
          reviewIndex +
          1
        ) %
        lightboxReviews.length;


      setReview(
        lightboxReviews[
          reviewIndex
        ],
        true
      );

    }


    /* =========================================================
       COUNTER + PRELOAD
       ========================================================= */

    function updateCounter() {

      if (
        !counter
      ) {
        return;
      }


      counter.textContent =
        (
          currentIndex +
          1
        ) +
        ' / ' +
        activeEntries.length;

    }


    function preloadEntry(entry) {

      if (
        !entry ||
        !entry.image
      ) {
        return;
      }


      const src =
        imageSource(
          entry.image
        );


      if (
        !src
      ) {
        return;
      }


      const preload =
        new Image();


      preload.src =
        src;

    }


    function preloadAdjacentEntries() {

      if (
        activeEntries.length <
        2
      ) {
        return;
      }


      preloadEntry(
        activeEntries[
          (
            currentIndex +
            1
          ) %
          activeEntries.length
        ]
      );


      preloadEntry(
        activeEntries[
          (
            currentIndex -
            1 +
            activeEntries.length
          ) %
          activeEntries.length
        ]
      );

    }


    /* =========================================================
       IMAGE UPDATE
       ========================================================= */

    function applyEntry(
      entry,
      animate,
      rotateReview
    ) {

      if (
        !entry ||
        !entry.image
      ) {
        return;
      }


      const src =
        imageSource(
          entry.image
        );


      if (
        !src
      ) {
        return;
      }


      const imageAlt =
        entry.image.alt ||
        entry.label ||
        'Custom laser engraved metal card';


      const token =
        ++imageSwapToken;


      let resolved =
        false;


      const ready =
        function () {

          if (
            resolved ||
            token !==
              imageSwapToken
          ) {
            return;
          }


          resolved =
            true;


          const swap =
            function () {

              if (
                token !==
                imageSwapToken
              ) {
                return;
              }


              lightboxImage.src =
                src;


              lightboxImage.alt =
                imageAlt;


              applyContext(
                entry
              );


              updateCounter();


              if (
                rotateReview
              ) {

                advanceReview();

              }


              requestAnimationFrame(
                function () {

                  lightboxImage.classList.remove(
                    'is-switching'
                  );

                }
              );

            };


          if (
            animate &&
            !prefersReducedMotion &&
            lightboxImage.src
          ) {

            lightboxImage.classList.add(
              'is-switching'
            );


            window.setTimeout(
              swap,
              105
            );

          } else {

            swap();

          }

        };


      const preload =
        new Image();


      preload.onload =
        ready;


      preload.onerror =
        ready;


      preload.src =
        src;


      if (
        preload.complete
      ) {

        ready();

      }

    }


    function updateLightboxEntry(
      index,
      options
    ) {

      if (
        !activeEntries.length
      ) {
        return;
      }


      options =
        options ||
        {};


      currentIndex =
        (
          index +
          activeEntries.length
        ) %
        activeEntries.length;


      const entry =
        activeEntries[
          currentIndex
        ];


      applyEntry(
        entry,
        options.animate !==
          false,
        options.rotateReview ===
          true
      );


      const showNavigation =
        activeEntries.length >
        1;


      if (prevButton) {

        prevButton.hidden =
          !showNavigation;

      }


      if (nextButton) {

        nextButton.hidden =
          !showNavigation;

      }


      if (counter) {

        counter.hidden =
          !showNavigation;

      }


      preloadAdjacentEntries();

    }


    function goPrevious() {

      if (
        activeEntries.length <
        2
      ) {
        return;
      }


      updateLightboxEntry(
        currentIndex -
        1,
        {
          animate:
            true,

          rotateReview:
            true
        }
      );

    }


    function goNext() {

      if (
        activeEntries.length <
        2
      ) {
        return;
      }


      updateLightboxEntry(
        currentIndex +
        1,
        {
          animate:
            true,

          rotateReview:
            true
        }
      );

    }


    /* =========================================================
       ANALYTICS
       ========================================================= */

    function pushEvent(
      name,
      extra
    ) {

      if (
        !Array.isArray(
          window.dataLayer
        )
      ) {
        return;
      }


      window.dataLayer.push(
        Object.assign(
          {
            event:
              name
          },
          extra ||
            {}
        )
      );

    }


    /* =========================================================
       OPEN / CLOSE
       ========================================================= */

    function openLightbox(entry) {

      if (
        !entry
      ) {
        return;
      }


      currentGroup =
        entry.group;


      activeEntries =
        groups[
          currentGroup
        ] ||
        [
          entry
        ];


      currentIndex =
        activeEntries.indexOf(
          entry
        );


      if (
        currentIndex ===
        -1
      ) {

        activeEntries =
          [
            entry
          ];


        currentIndex =
          0;

      }


      if (
        currentGroup ===
        'featured'
      ) {

        chooseRandomFeaturedHeadline();

      }


      lastFocusedElement =
        document.activeElement;


      previousBodyOverflow =
        document.body.style.overflow;


      showRandomReview();


      updateLightboxEntry(
        currentIndex,
        {
          animate:
            false,

          rotateReview:
            false
        }
      );


      lightbox.hidden =
        false;


      lightbox.setAttribute(
        'aria-hidden',
        'false'
      );


      document.body.style.overflow =
        'hidden';


      requestAnimationFrame(
        function () {

          if (
            closeButton
          ) {

            closeButton.focus();

          }

        }
      );


      pushEvent(
        'gallery_lightbox_open',
        {
          lightbox_group:
            currentGroup,

          gallery_image:
            entry.image
              ? (
                  entry.image.alt ||
                  entry.label ||
                  ''
                )
              : ''
        }
      );

    }


    function closeLightbox() {

      if (
        lightbox.hidden
      ) {
        return;
      }


      lightbox.hidden =
        true;


      lightbox.setAttribute(
        'aria-hidden',
        'true'
      );


      lightboxImage.src =
        '';


      lightboxImage.classList.remove(
        'is-switching'
      );


      document.body.style.overflow =
        previousBodyOverflow;


      if (
        lastFocusedElement &&
        typeof lastFocusedElement.focus ===
          'function'
      ) {

        lastFocusedElement.focus();

      }

    }


    /* =========================================================
       ACCESSIBILITY + CLICK EVENTS
       ========================================================= */

    function setupTrigger(entry) {

      const trigger =
        entry.trigger;


      if (
        !trigger ||
        trigger.dataset.sharedLightboxBound ===
          'true'
      ) {
        return;
      }


      trigger.dataset.sharedLightboxBound =
        'true';


      const tagName =
        (
          trigger.tagName ||
          ''
        ).toLowerCase();


      const nativeInteractive =
        tagName ===
          'button' ||
        tagName ===
          'a';


      if (
        !nativeInteractive
      ) {

        trigger.setAttribute(
          'tabindex',
          '0'
        );


        trigger.setAttribute(
          'role',
          'button'
        );

      }


      let ariaLabel =
        'View larger';


      if (
        entry.group ===
        'colors'
      ) {

        ariaLabel =
          'View ' +
          (
            entry.label ||
            'color'
          ) +
          ' metal card';

      } else if (
        entry.group ===
        'styles'
      ) {

        ariaLabel =
          'Explore ' +
          (
            entry.label ||
            'metal card style'
          );

      } else {

        ariaLabel =
          'View larger: ' +
          (
            entry.image.alt ||
            entry.label ||
            'custom metal project'
          );

      }


      trigger.setAttribute(
        'aria-label',
        ariaLabel
      );


      trigger.addEventListener(
        'click',
        function (
          event
        ) {

          if (
            tagName ===
            'a'
          ) {

            event.preventDefault();

          }


          openLightbox(
            entry
          );

        }
      );


      if (
        !nativeInteractive
      ) {

        trigger.addEventListener(
          'keydown',
          function (
            event
          ) {

            if (
              event.key ===
                'Enter' ||
              event.key ===
                ' '
            ) {

              event.preventDefault();


              openLightbox(
                entry
              );

            }

          }
        );

      }

    }


    allEntries.forEach(
      setupTrigger
    );


    /* =========================================================
       FOCUS TRAP
       ========================================================= */

    function trapFocus(event) {

      if (
        event.key !==
          'Tab' ||
        lightbox.hidden
      ) {
        return;
      }


      const focusable =
        Array.from(
          lightbox.querySelectorAll(
            'button:not([disabled]):not([hidden]), a[href]:not([hidden]), [tabindex]:not([tabindex="-1"]):not([hidden])'
          )
        )
          .filter(
            function (
              element
            ) {

              return (
                element.offsetParent !==
                null
              );

            }
          );


      if (
        !focusable.length
      ) {
        return;
      }


      const first =
        focusable[
          0
        ];


      const last =
        focusable[
          focusable.length -
          1
        ];


      if (
        event.shiftKey &&
        document.activeElement ===
          first
      ) {

        event.preventDefault();

        last.focus();

      } else if (
        !event.shiftKey &&
        document.activeElement ===
          last
      ) {

        event.preventDefault();

        first.focus();

      }

    }


    /* =========================================================
       CONTROLS
       ========================================================= */

    if (
      closeButton
    ) {

      closeButton.addEventListener(
        'click',
        closeLightbox
      );

    }


    if (
      prevButton
    ) {

      prevButton.addEventListener(
        'click',
        goPrevious
      );

    }


    if (
      nextButton
    ) {

      nextButton.addEventListener(
        'click',
        goNext
      );

    }


    lightbox.addEventListener(
      'click',
      function (
        event
      ) {

        if (
          event.target ===
          lightbox
        ) {

          closeLightbox();

        }

      }
    );


    document.addEventListener(
      'keydown',
      function (
        event
      ) {

        if (
          lightbox.hidden
        ) {
          return;
        }


        trapFocus(
          event
        );


        if (
          event.key ===
          'Escape'
        ) {

          closeLightbox();

        }


        if (
          event.key ===
          'ArrowLeft'
        ) {

          goPrevious();

        }


        if (
          event.key ===
          'ArrowRight'
        ) {

          goNext();

        }

      }
    );


    /* =========================================================
       MOBILE SWIPE
       ========================================================= */

    if (
      media
    ) {

      media.addEventListener(
        'pointerdown',
        function (
          event
        ) {

          if (
            event.pointerType ===
            'mouse'
          ) {
            return;
          }


          if (
            event.target.closest(
              'button,a'
            )
          ) {
            return;
          }


          if (
            activeEntries.length <
            2
          ) {
            return;
          }


          touchStartX =
            event.clientX;


          touchStartY =
            event.clientY;

        }
      );


      media.addEventListener(
        'pointerup',
        function (
          event
        ) {

          if (
            event.pointerType ===
            'mouse'
          ) {
            return;
          }


          if (
            activeEntries.length <
            2
          ) {

            touchStartX =
              null;


            touchStartY =
              null;


            return;

          }


          if (
            touchStartX ===
              null ||
            touchStartY ===
              null
          ) {
            return;
          }


          const deltaX =
            event.clientX -
            touchStartX;


          const deltaY =
            event.clientY -
            touchStartY;


          touchStartX =
            null;


          touchStartY =
            null;


          if (
            Math.abs(
              deltaX
            ) <
            50
          ) {
            return;
          }


          if (
            Math.abs(
              deltaX
            ) <=
            Math.abs(
              deltaY
            ) *
            1.2
          ) {
            return;
          }


          if (
            deltaX <
            0
          ) {

            goNext();

          } else {

            goPrevious();

          }

        }
      );


      media.addEventListener(
        'pointercancel',
        function () {

          touchStartX =
            null;


          touchStartY =
            null;

        }
      );

    }


    /* =========================================================
       ANALYTICS EVENTS
       ========================================================= */

    if (
      primaryCta
    ) {

      primaryCta.addEventListener(
        'click',
        function () {

          const entry =
            activeEntries[
              currentIndex
            ];


          pushEvent(
            'gallery_lightbox_primary_cta',
            {
              lightbox_group:
                currentGroup,

              gallery_image:
                entry &&
                entry.image
                  ? (
                      entry.image.alt ||
                      entry.label ||
                      ''
                    )
                  : '',

              cta_text:
                primaryCta.textContent ||
                '',

              destination:
                primaryCta.href ||
                ''
            }
          );

        }
      );

    }


    if (
      collectionLink
    ) {

      collectionLink.addEventListener(
        'click',
        function () {

          pushEvent(
            'gallery_lightbox_collection_click',
            {
              lightbox_group:
                currentGroup,

              destination:
                collectionLink.href
            }
          );

        }
      );

    }


    if (
      bulkLink
    ) {

      bulkLink.addEventListener(
        'click',
        function () {

          pushEvent(
            'gallery_lightbox_bulk_click',
            {
              lightbox_group:
                currentGroup
            }
          );

        }
      );

    }


    if (
      contactLink
    ) {

      contactLink.addEventListener(
        'click',
        function () {

          pushEvent(
            'gallery_lightbox_contact_click',
            {
              lightbox_group:
                currentGroup
            }
          );

        }
      );

    }

  }


  function startSharedLightbox() {
    initSharedLightbox();
  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      startSharedLightbox,
      {
        once:
          true
      }
    );

  } else {

    startSharedLightbox();

  }


  document.addEventListener(
    'shopify:section:load',
    function () {

      window.setTimeout(
        initSharedLightbox,
        0
      );

    }
  );

})();



/* =========================================================
   METAL TAROT COLLECTION GALLERY

   WORKS WITH:
   #metal-tarot-experience
   #tarot-gallery-more
   #tarot-gallery-see-more
   [data-tarot-gallery-item]
   #tarot-gallery-lightbox
   ========================================================= */

(function () {
  'use strict';


  let currentIndex =
    0;


  let previousBodyOverflow =
    '';


  let lastFocusedElement =
    null;


  let touchStartX =
    null;


  let touchStartY =
    null;



  /* =========================================================
     HELPERS
     ========================================================= */

  function getRoot() {

    return document.getElementById(
      'metal-tarot-experience'
    );

  }


  function getLightbox() {

    return document.getElementById(
      'tarot-gallery-lightbox'
    );

  }


  function getItems() {

    const root =
      getRoot();


    if (
      !root
    ) {
      return [];
    }


    return Array.from(
      root.querySelectorAll(
        '[data-tarot-gallery-item]'
      )
    );

  }



  /* =========================================================
     SEE MORE / SHOW LESS
     ========================================================= */

  function setMoreState(open) {

    const more =
      document.getElementById(
        'tarot-gallery-more'
      );


    const button =
      document.getElementById(
        'tarot-gallery-see-more'
      );


    if (
      !more ||
      !button
    ) {
      return;
    }


    const label =
      button.querySelector(
        '.tarot-see-more-label'
      );


    const arrow =
      button.querySelector(
        '.tarot-button-arrow'
      );


    more.classList.toggle(
      'is-open',
      open
    );


    more.setAttribute(
      'aria-hidden',
      open
        ? 'false'
        : 'true'
    );


    button.setAttribute(
      'aria-expanded',
      open
        ? 'true'
        : 'false'
    );


    if (
      label
    ) {

      label.textContent =
        open
          ? 'SHOW LESS GALLERY'
          : 'SEE MORE TAROT CARDS';

    }


    if (
      arrow
    ) {

      arrow.textContent =
        open
          ? '↑'
          : '↓';

    }

  }


  function toggleMore() {

    const button =
      document.getElementById(
        'tarot-gallery-see-more'
      );


    if (
      !button
    ) {
      return;
    }


    setMoreState(
      button.getAttribute(
        'aria-expanded'
      ) !==
        'true'
    );

  }



  /* =========================================================
     TAROT CTA TEXT
     ========================================================= */

  function productCtaText(title) {

    const normalized =
      String(
        title ||
        ''
      ).toLowerCase();


    if (
      normalized.includes(
        'complete metal tarot card deck'
      )
    ) {

      return 'VIEW COMPLETE TAROT DECK →';

    }


    if (
      normalized.includes(
        'major arcana set'
      )
    ) {

      return 'VIEW MAJOR ARCANA SET →';

    }


    if (
      normalized.includes(
        'rose gold'
      )
    ) {

      return 'VIEW METAL TAROT COLLECTION →';

    }


    return (
      'VIEW ' +
      String(
        title ||
        'THIS TAROT CARD'
      ).toUpperCase() +
      ' →'
    );

  }



  /* =========================================================
     UPDATE TAROT LIGHTBOX
     ========================================================= */

  function updateTarotLightbox(index) {

    const box =
      getLightbox();


    const items =
      getItems();


    if (
      !box ||
      !items.length
    ) {
      return;
    }


    currentIndex =
      (
        index +
        items.length
      ) %
      items.length;


    const item =
      items[
        currentIndex
      ];


    const sourceImage =
      item.querySelector(
        'img'
      );


    if (
      !sourceImage
    ) {
      return;
    }


    const image =
      box.querySelector(
        '[data-tarot-image]'
      );


    const counter =
      box.querySelector(
        '[data-tarot-counter]'
      );


    const kicker =
      box.querySelector(
        '[data-tarot-kicker]'
      );


    const headline =
      box.querySelector(
        '[data-tarot-headline]'
      );


    const productLink =
      box.querySelector(
        '[data-tarot-product-link]'
      );


    const prev =
      box.querySelector(
        '[data-tarot-prev]'
      );


    const next =
      box.querySelector(
        '[data-tarot-next]'
      );


    const title =
      item.getAttribute(
        'data-title'
      ) ||
      'Metal Tarot Card';


    const productUrl =
      item.getAttribute(
        'data-product-url'
      ) ||
      '/collections/metal-tarot-cards';



    /* IMAGE */

    if (
      image
    ) {

      image.src =
        sourceImage.currentSrc ||
        sourceImage.getAttribute(
          'src'
        ) ||
        '';


      image.alt =
        sourceImage.alt ||
        title;

    }



    /* COUNTER */

    if (
      counter
    ) {

      counter.textContent =
        (
          currentIndex +
          1
        ) +
        ' / ' +
        items.length;


      counter.hidden =
        items.length <
        2;

    }



    /* KICKER */

    if (
      kicker
    ) {

      kicker.textContent =
        title.toUpperCase();

    }



    /* HEADLINE */

    if (
      headline
    ) {

      headline.textContent =
        title;

    }



    /* PRODUCT-SPECIFIC LINK */

    if (
      productLink
    ) {

      productLink.href =
        productUrl;


      productLink.textContent =
        productCtaText(
          title
        );

    }



    /* NAVIGATION */

    if (
      prev
    ) {

      prev.hidden =
        items.length <
        2;

    }


    if (
      next
    ) {

      next.hidden =
        items.length <
        2;

    }

  }



  /* =========================================================
     OPEN TAROT LIGHTBOX
     ========================================================= */

  function openTarotLightbox(index) {

    const box =
      getLightbox();


    if (
      !box
    ) {
      return;
    }


    lastFocusedElement =
      document.activeElement;


    previousBodyOverflow =
      document.body.style.overflow;


    updateTarotLightbox(
      index
    );


    box.hidden =
      false;


    box.setAttribute(
      'aria-hidden',
      'false'
    );


    document.body.style.overflow =
      'hidden';


    const close =
      box.querySelector(
        '[data-tarot-close]'
      );


    requestAnimationFrame(
      function () {

        if (
          close
        ) {

          close.focus();

        }

      }
    );

  }



  /* =========================================================
     CLOSE TAROT LIGHTBOX
     ========================================================= */

  function closeTarotLightbox() {

    const box =
      getLightbox();


    if (
      !box ||
      box.hidden
    ) {
      return;
    }


    box.hidden =
      true;


    box.setAttribute(
      'aria-hidden',
      'true'
    );


    document.body.style.overflow =
      previousBodyOverflow;


    const image =
      box.querySelector(
        '[data-tarot-image]'
      );


    if (
      image
    ) {

      image.src =
        '';

    }


    if (
      lastFocusedElement &&
      typeof lastFocusedElement.focus ===
        'function'
    ) {

      lastFocusedElement.focus();

    }

  }



  /* =========================================================
     NEXT / PREVIOUS
     ========================================================= */

  function nextTarotImage() {

    const items =
      getItems();


    if (
      items.length <
      2
    ) {
      return;
    }


    updateTarotLightbox(
      currentIndex +
      1
    );

  }


  function previousTarotImage() {

    const items =
      getItems();


    if (
      items.length <
      2
    ) {
      return;
    }


    updateTarotLightbox(
      currentIndex -
      1
    );

  }



  /* =========================================================
     BIND TAROT GALLERY
     ========================================================= */

  function bindTarotGallery() {

    const root =
      getRoot();


    if (
      !root
    ) {
      return;
    }



    /* =====================================================
       SEE MORE
       ===================================================== */

    const moreButton =
      document.getElementById(
        'tarot-gallery-see-more'
      );


    const more =
      document.getElementById(
        'tarot-gallery-more'
      );


    if (
      moreButton &&
      more &&
      moreButton.dataset.tarotMoreBound !==
        'true'
    ) {

      moreButton.dataset.tarotMoreBound =
        'true';


      moreButton.addEventListener(
        'click',
        function (
          event
        ) {

          event.preventDefault();

          toggleMore();

        }
      );

    }



    /* =====================================================
       GALLERY ITEMS
       ===================================================== */

    getItems().forEach(
      function (
        item,
        index
      ) {

        if (
          item.dataset.tarotLightboxBound ===
          'true'
        ) {
          return;
        }


        item.dataset.tarotLightboxBound =
          'true';


        item.addEventListener(
          'click',
          function (
            event
          ) {

            event.preventDefault();


            openTarotLightbox(
              index
            );

          }
        );

      }
    );



    /* =====================================================
       LIGHTBOX CONTROLS
       ===================================================== */

    const box =
      getLightbox();


    if (
      !box ||
      box.dataset.tarotControlsBound ===
        'true'
    ) {
      return;
    }


    box.dataset.tarotControlsBound =
      'true';


    const close =
      box.querySelector(
        '[data-tarot-close]'
      );


    const prev =
      box.querySelector(
        '[data-tarot-prev]'
      );


    const next =
      box.querySelector(
        '[data-tarot-next]'
      );


    const media =
      box.querySelector(
        '.gallery-lightbox-media'
      );



    /* CLOSE */

    if (
      close
    ) {

      close.addEventListener(
        'click',
        function (
          event
        ) {

          event.preventDefault();

          closeTarotLightbox();

        }
      );

    }



    /* PREVIOUS */

    if (
      prev
    ) {

      prev.addEventListener(
        'click',
        function (
          event
        ) {

          event.preventDefault();

          event.stopPropagation();

          previousTarotImage();

        }
      );

    }



    /* NEXT */

    if (
      next
    ) {

      next.addEventListener(
        'click',
        function (
          event
        ) {

          event.preventDefault();

          event.stopPropagation();

          nextTarotImage();

        }
      );

    }



    /* BACKDROP */

    box.addEventListener(
      'click',
      function (
        event
      ) {

        if (
          event.target ===
          box
        ) {

          closeTarotLightbox();

        }

      }
    );



    /* =====================================================
       MOBILE SWIPE
       ===================================================== */

    if (
      media
    ) {

      media.addEventListener(
        'pointerdown',
        function (
          event
        ) {

          if (
            event.pointerType ===
            'mouse'
          ) {
            return;
          }


          if (
            event.target.closest(
              'button,a'
            )
          ) {
            return;
          }


          touchStartX =
            event.clientX;


          touchStartY =
            event.clientY;

        }
      );


      media.addEventListener(
        'pointerup',
        function (
          event
        ) {

          if (
            event.pointerType ===
            'mouse'
          ) {
            return;
          }


          if (
            touchStartX ===
              null ||
            touchStartY ===
              null
          ) {
            return;
          }


          const deltaX =
            event.clientX -
            touchStartX;


          const deltaY =
            event.clientY -
            touchStartY;


          touchStartX =
            null;


          touchStartY =
            null;


          if (
            Math.abs(
              deltaX
            ) <
            50
          ) {
            return;
          }


          if (
            Math.abs(
              deltaX
            ) <=
            Math.abs(
              deltaY
            ) *
            1.2
          ) {
            return;
          }


          if (
            deltaX <
            0
          ) {

            nextTarotImage();

          } else {

            previousTarotImage();

          }

        }
      );


      media.addEventListener(
        'pointercancel',
        function () {

          touchStartX =
            null;


          touchStartY =
            null;

        }
      );

    }

  }



  /* =========================================================
     KEYBOARD
     ========================================================= */

  document.addEventListener(
    'keydown',
    function (
      event
    ) {

      const box =
        getLightbox();


      if (
        !box ||
        box.hidden
      ) {
        return;
      }


      if (
        event.key ===
        'Escape'
      ) {

        event.preventDefault();

        closeTarotLightbox();

      } else if (
        event.key ===
        'ArrowLeft'
      ) {

        event.preventDefault();

        previousTarotImage();

      } else if (
        event.key ===
        'ArrowRight'
      ) {

        event.preventDefault();

        nextTarotImage();

      }

    }
  );



  /* =========================================================
     START
     ========================================================= */

  function startTarotGallery() {

    bindTarotGallery();

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      startTarotGallery,
      {
        once:
          true
      }
    );

  } else {

    startTarotGallery();

  }



  /* =========================================================
     SHOPIFY THEME EDITOR SUPPORT
     ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    function () {

      window.setTimeout(
        bindTarotGallery,
        0
      );

    }
  );

})();